import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesBrowserBugs2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.52 22.85h28.95v3.05H32V1.52h-1.53v19.81H1.52V1.52H0V25.9h1.52z\"/><path fill=\"currentColor\" d=\"M1.52 25.9v1.52h9.15v1.53h1.52v-1.53h7.62v1.53h1.52v-1.53h9.14V25.9zM21.33 6.09h1.53v3.05h-1.53ZM10.67 30.47v-1.52H9.14V32h13.72v-3.05h-1.53v1.52zm7.61-22.86V4.57h1.53V3.04h-3.05v3.05h-1.52V3.04h-3.05v1.53h1.52v3.04z\"/><path fill=\"currentColor\" d=\"M10.67 16.76H9.14v3.05h1.53v-1.53h3.04v1.53h4.57v-1.53h3.05v1.53h1.53v-3.05h-1.53v-3.05h3.05v-1.52h-3.05V9.14h-1.52V7.61h-1.53v1.53h-4.57V7.61h-1.52v1.53h-1.52v3.05H7.62v1.52h3.05Zm1.52-4.57h7.62v1.52h-3.05v4.57h-1.52v-4.57h-3.05Z\"/><path fill=\"currentColor\" d=\"M9.14 6.09h1.53v3.05H9.14ZM1.52 0h28.95v1.52H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesBrowserBugs2
